import isReadOnlyProperty from './isReadOnlyProperty';
import toPropertyName from './toPropertyName';
import isComputedProperty from './isComputedProperty';
import {memoize} from '@servicenow/ui-internal';

export default memoize(
	function shouldSetProperty(tagName, name, defs = {}, setReadOnly = false) {
		const propertyName = toPropertyName(name);
		const readOnly = isReadOnlyProperty(propertyName, defs);
		const computedProperty = isComputedProperty(propertyName, defs);

		return (!readOnly || (readOnly && setReadOnly)) && !computedProperty;
	},
	{
		createCacheKey: (tagName, name, defs, setReadOnly) => `${tagName}|${name}|${setReadOnly}`,
		profileName: 'shouldSetProperty'
	}
);
